var _this = this,
    _jsxFileName = "/builds/zillow/adtech-product/constellation/zrs-cms-messaging/src/img/HourglassIcon.jsx";

import React from 'react';
import PropTypes from 'prop-types';

var HourglassIcon = function HourglassIcon(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/React.createElement("svg", {
    width: "39",
    height: "44",
    viewBox: "-12 -6 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("title", {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 13,
      columnNumber: 9
    }
  }, "Hourglass Icon"), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 14,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9287 10.9286C11.0425 12.8914 12.6087 14.4576 14.5716 14.5714C16.5344 14.4576 18.1006 12.8914 18.2144 10.9286L10.9287 10.9286Z",
    fill: "#006AFF",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 15,
      columnNumber: 13
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5079 31.5714H27.9286C28.5992 31.5714 29.1429 32.1151 29.1429 32.7857C29.1429 33.4563 28.5992 34 27.9286 34H1.21429C0.543654 34 0 33.4563 0 32.7857C0 32.1151 0.543654 31.5714 1.21429 31.5714H2.67143C3.485 26.1314 6.64214 18.8214 9.71429 17C6.60571 15.1786 3.44857 7.86857 2.635 2.42857H1.21429C0.543654 2.42857 0 1.88492 0 1.21429C0 0.543654 0.543654 0 1.21429 0H27.9286C28.5992 0 29.1429 0.543654 29.1429 1.21429C29.1429 1.88492 28.5992 2.42857 27.9286 2.42857H26.5079C25.6943 7.86857 22.5371 15.1786 19.465 17C22.5371 18.8214 25.6943 26.1314 26.5079 31.5714ZM14.5715 23.0714C16.3929 23.0714 21.8572 27.9286 21.8572 31.5714H24.0672C23.2536 26.7143 20.4365 20.4 18.2264 19.0886C17.4892 18.6511 17.0372 17.8573 17.0372 17C17.0372 16.1427 17.4892 15.3489 18.2264 14.9114C20.4243 13.6 23.2536 7.28571 24.0672 2.42857H5.07574C5.88931 7.28571 8.70645 13.6 10.9165 14.9114C11.6537 15.3489 12.1057 16.1427 12.1057 17C12.1057 17.8573 11.6537 18.6511 10.9165 19.0886C8.71859 20.4 5.88931 26.7143 5.07574 31.5714H7.28574C7.28574 27.9286 12.75 23.0714 14.5715 23.0714Z",
    fill: "#006AFF",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 19,
      columnNumber: 13
    }
  })), /*#__PURE__*/React.createElement("defs", {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 26,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 27,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement("rect", {
    width: "39",
    height: "44",
    fill: "white",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 28,
      columnNumber: 17
    }
  }))));
};

HourglassIcon.propTypes = process.env.NODE_ENV !== "production" ? {
  className: PropTypes.string
} : {};
HourglassIcon.defaultProps = {
  className: null
};
export default HourglassIcon;